export function buildStreamItemShareUrl(streamId) {
  return `${process.env.REACT_APP_API_URL}/stream_items/${streamId}`;
}
